import React from 'react';
import TableDataField from './TableDataField';

const CodeTTMField = ({ codeTTM }) => {
    return (
        <TableDataField extraStyling="col-small">
            {codeTTM}
        </TableDataField>
    );
};

export default CodeTTMField;
